import contractFactory from 'truffle-contract';

export default (contractJSON) => ({ account, web3 }) => {
  const contract = contractFactory(contractJSON);

  account.subscribe(update => contract.defaults({ from: update.account }));

  function setup() {
    return contract.currentProvider ? Promise.resolve() : web3.then(w3 => contract.setProvider(w3.currentProvider))
  }

  return {
    deployed: () => setup().then(() => contract.deployed()),
    at: (address) => setup().then(() => contract.at(address))
  }
}


// WEBPACK FOOTER //
// ./src/api/contract.js